import React from "react";
import { FileArtifactProto } from "build-ts/dataframe";
import FileArtifactComponent from "../components/FileArtifact";

interface FileArtifactContainerProps {
  data: FileArtifactProto;
  onClose?: () => void;
  /** No-op in the panel context — collapse is handled by the artifact strip. */
  collapseSignal?: number;
  isExpanded?: boolean;
  onExpandToggle?: () => void;
}

/**
 * Container for FILE_ARTIFACT artifacts.
 * Hydration is handled by useArtifactPanel before the panel renders.
 */
const FileArtifactContainer: React.FC<FileArtifactContainerProps> = ({ data, isExpanded, onExpandToggle }) => {
  return <FileArtifactComponent data={data} isExpanded={isExpanded} onExpandToggle={onExpandToggle} />;
};

export default FileArtifactContainer;
